
import { light } from './light'
import { dark } from './dark'


export const themes = {
    light,
    dark

}